import resume from "../assets/pdf/resume.pdf";

export const headerData = {
  name: "Mrityunjay Kumar Gupta",
  title: "Front-End Developer",
  desciption:
    "Don’t compare yourself with anyone in this world…if you do so, you are insulting yourself.",
  resumePdf: resume,
};
